module.exports = __webpack_public_path__ + "static/About-light-c0070fae30b397085da84064bfb3004e.svg";